import React from "react";
import ContentLoader from "react-content-loader";

export default ({
  times,
  height,
  width,
  speed,
  primaryColor,
  secondaryColor,
  parentClass,
  children
}) => {
  const defaultTimes = (Number.isInteger(times) && times) || 5;
  const template = [];
  for (let index = 0; index < defaultTimes; index++) {
    template.push(
      <div className={parentClass} key={`loader--key-${index}`}>
        <ContentLoader
          height={height || 160}
          width={width || 400}
          speed={speed || 1}
          primaryColor={primaryColor || "#d9d9d9"}
          secondaryColor={secondaryColor || "#ecebeb"}
        >
          {children}
        </ContentLoader>
      </div>
    );
  }
  return (
    <tbody>
      <tr>
        <td colSpan="4">{template}</td>
      </tr>
    </tbody>
  );
};
